import API from './utils/API'

const api = new API()
const prefix = '/admin'

const generateMfaCode = (data) =>
  api
    .callApi({
      url: `${prefix}/mfa-code`,
      method: 'post',
      data,
    })
    .then((result) => result.data.result)

export default {
  generateMfaCode,
}
